<template>
  <div class="form-content">
    <div class="header-box">
      <i class="header-icon"></i>
      <!-- <img class="header-img" :src="require('@/assets/imgs/person.png')" /> -->
      <label class="header-name">投保人信息</label>
    </div>
    <div class="idcard-box">
      <div class="carimg-box" v-show="isShowFiled('urlCardFront')">
        <div
          class="img-item"
          v-if="$ComTools.isEmptyString(dataForm.urlCardFront)"
          @click="handleUploadClick(1)"
          :style="{
            backgroundImage:
              'url(' + require('@/assets/imgs/upload/id_card_front.png') + ')',
          }"
        ></div>
        <div class="view-item" @click="handleUploadClick(1)" v-else>
          <img :src="imgCardFrontBase64" />
        </div>
        <input
          type="file"
          ref="rfile1"
          @change="handleUploadChange($event, 1)"
          multiple
          style="display: none"
          accept="image/*"
        />
      </div>
      <div class="carimg-box" v-show="isShowFiled('urlCardVerso')">
        <div
          class="img-item"
          v-if="$ComTools.isEmptyString(dataForm.urlCardVerso)"
          @click="handleUploadClick(2)"
          :style="{
            backgroundImage:
              'url(' + require('@/assets/imgs/upload/id_card_verso.png') + ')',
          }"
        ></div>
        <div class="view-item" @click="handleUploadClick(2)" v-else>
          <img :src="imgCardVersoBase64" />
        </div>
        <input
          type="file"
          ref="rfile2"
          @change="handleUploadChange($event, 2)"
          multiple
          style="display: none"
          accept="image/*"
        />
      </div>
    </div>
    <van-form>
      <van-field
        v-show="isShowFiled('insureMobile')"
        v-model="dataForm.insureMobile"
        name="手机号"
        :label="getFiledName('insureMobile')"
        :placeholder="getPlaceHolderName('insureMobile')"
      />
      <van-field
        v-show="$ComTools.isEmptyString(userInfo.id) && isShowFiled('code')"
        v-model="dataForm.code"
        name="验证码"
        :label="getFiledName('code')"
        :placeholder="getPlaceHolderName('code')"
      >
        <template #button>
          <van-button
            size="small"
            :disabled="msgCount <= 60"
            type="primary"
            @click="handleSendMsgClick"
            >{{ msgName }}</van-button
          >
        </template>
      </van-field>
      <van-field
        readonly
        clickable
        name="保险产品"
        label="保险产品"
        :value="productValue"
        :placeholder="getPlaceHolderName('productValue')"
        @click="showProductPicker = true"
      />
      <van-field
        v-show="isShowFiled('password')"
        v-model="dataForm.password"
        name="122密码"
        :label="getFiledName('password')"
        :placeholder="getPlaceHolderName('password')"
      />
      <div class="header-box">
        <i class="header-icon"></i>
        <!-- <img class="header-img" :src="require('@/assets/imgs/person.png')" /> -->
        <label class="header-name">被保人信息</label>
      </div>
      <van-field
        v-show="isShowFiled('relationName')"
        v-model="relationName"
        name="与投保人关系"
        :label="getFiledName('relationName')"
        readonly
        :placeholder="getPlaceHolderName('relationName')"
      />
      <van-field
        v-show="isShowFiled('insureName')"
        v-model="dataForm.insureName"
        name="姓名"
        :label="getFiledName('insureName')"
        readonly
        :placeholder="getPlaceHolderName('insureName')"
      />
      <van-field
        v-show="isShowFiled('insureSexName')"
        v-model="insureSexName"
        name="性别"
        :label="getFiledName('insureSexName')"
        readonly
        :placeholder="getPlaceHolderName('insureSexName')"
      />
      <van-field
        v-show="isShowFiled('insureBirthday')"
        v-model="insureBirthday"
        name="出生日期"
        :label="getFiledName('insureBirthday')"
        readonly
        :placeholder="getPlaceHolderName('insureBirthday')"
      />
      <van-field
        v-show="isShowFiled('insureIdNo')"
        v-model="dataForm.insureIdNo"
        name="身份证号"
        :label="getFiledName('insureIdNo')"
        readonly
        :placeholder="getPlaceHolderName('insureIdNo')"
      />
      <van-field
        v-show="isShowFiled('insureAddress')"
        v-model="dataForm.insureAddress"
        name="地址"
        :label="getFiledName('insureAddress')"
        readonly
        :placeholder="getPlaceHolderName('insureAddress')"
      />
      <div class="header-box">
        <i class="header-icon"></i>
        <!-- <img class="header-img" :src="require('@/assets/imgs/person.png')" /> -->
        <label class="header-name">保障信息</label>
      </div>
      <van-field
        v-model="dataForm.period"
        name="保障期限"
        label="保障期限"
        readonly
        placeholder
      />
      <van-field
        v-model="forceTimeName"
        name="生效日期"
        label="生效日期"
        readonly
        placeholder
      />
    </van-form>
    <van-popup v-model="showProductPicker" position="bottom">
      <van-picker
        show-toolbar
        value-key="allName"
        :columns="productLists"
        @confirm="handleProductPickerOk"
        @cancel="showProductPicker = false"
      />
    </van-popup>
    <div class="check-box">
      <van-checkbox v-model="checked" shape="square" icon-size="20px"
        >我已阅读并确认</van-checkbox
      >
      <label
        class="link-book"
        @click="handleShowBlookClick(item.value)"
        v-for="(item, idx) in authorize"
        :key="idx"
        >{{ item.name }}</label
      >
    </div>
    <div style="height: 5rem"></div>
    <div class="button-save">
      <van-button
        @click="checked ? handleGoClick() : () => {}"
        type="primary"
        block
        :color="checked ? '#FFC281' : '#C0C0C0'"
        >前往支付</van-button
      >
    </div>
  </div>
</template>

<script>
import { Toast, Notify } from "vant";
import {
  uploadIdCard,
  getVerification,
  createInsure,
  getJsapiTicket,
  findCategoryById,
  findCategoryByProductId,
} from "@/api/common";
import { isMobile, isCard } from "@/utils/validate";
export default {
  data() {
    return {
      imgCardVersoBase64: "",
      imgCardFrontBase64: "",
      showUploadLoading: false,
      showProductPicker: false,
      checked: false,
      relationName: "本人",
      insureSexName: "",
      forceTimeName: "",
      productOptions: [],
      productLists: [],
      insureBirthday: "",
      dataForm: {
        urlCardVerso: "",
        urlCardFront: "",
        insureMobile: "",
        categoryId: "",
        password: "",
        relation: "1",
        insureName: "",
        insureSex: "",
        insurantCardType: 1,
        insureIdNo: "",
        insureAddress: "",
        period: "",
        forceTime: "2020-09-01",
        code: "",
        platformId: "",
      },
      productValue: "",
      msgName: "获取验证码",
      msgCount: 61,
      belongerId: "",
      itemindex: 1,
      filedOptions: {},
      authorize: [],
    };
  },
  activated() {
    document.title = "阳光保险驾考宝";
    this.belongerId = this.$route.query.belongerId || "";
    this.itemindex = this.$route.query.categoryId || "";
    this.dataForm.platformId = this.$route.query.platformId || "";
    this.dataForm.categoryId = this.itemindex;
    this._findCategoryByProductId();
    this._findCategoryById();
    //this.setValue(this.itemindex);
  },
  computed: {
    userInfo: {
      get() {
        return this.$store.state.user.userInfo || {};
      },
    },
  },
  mounted() {
    let sUrl = location.href.split("#")[0];
    let sImgUrl = "http://nywx.e-ibdt.cn/file/logo/logo_sinosig.png";
    getJsapiTicket({ appid: process.env.WXKey, url: sUrl }).then((res) => {
      if (res.code === 0) {
        this.$ComTools.wxShare(res.data, sUrl, sImgUrl, "阳光保险驾考宝");
      }
    });
  },
  methods: {
    _findCategoryByProductId() {
      this.productOptions = [];
      this.productLists = [];
      findCategoryByProductId({ productId: 1 }).then((res) => {
        if (res.code == 0) {
          this.productOptions = res.data.list;
          for (let i = 0; i < this.productOptions.length; i++) {
            let oProduct = this.productOptions[i];
            if (this.itemindex == oProduct.id) {
              this.productValue = oProduct.allName;
              this.setValue(oProduct);
            }
            this.productLists.push(this.$ComTools.assertOfDepth(oProduct));
          }
        }
      });
    },
    //获取动态的表字段
    _findCategoryById() {
      this.filedOptions = {};
      findCategoryById({ id: this.dataForm.categoryId }).then((res) => {
        this.authorize = this.$ComTools.isEmptyString(res.data.authorize)
          ? []
          : JSON.parse(res.data.authorize);
        console.log(this.authorize);
        let data = res.data;
        let sFileds = data.fieldJson;
        if (!this.$ComTools.isEmptyString(sFileds)) {
          let aFileds = JSON.parse(sFileds);
          for (let i = 0; i < aFileds.length; i++) {
            let obj = aFileds[i];
            let sKey = obj.key;
            let oValue = this.filedOptions[sKey];
            if (this.$ComTools.isEmptyString(oValue)) {
              this.filedOptions[sKey] = obj;
            }
          }
        }
        this.$forceUpdate();
      });
    },
    //判断是否展示该字段
    isShowFiled(key) {
      let obj = this.filedOptions[key];
      if (!this.$ComTools.isEmptyString(obj)) {
        if (obj.write == 1) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    isNeedVerify(key) {
      let obj = this.filedOptions[key];
      if (!this.$ComTools.isEmptyString(obj)) {
        if (obj.write == 1 && obj.required == 1) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    //获取动态字段名称
    getFiledName(key) {
      let obj = this.filedOptions[key];
      if (!this.$ComTools.isEmptyString(obj)) {
        let sDefaultValue = obj.defaultValue || "";
        if (!this.$ComTools.isEmptyString(sDefaultValue)) {
          this.dataForm[key] = sDefaultValue;
        }
        return obj.name;
      } else {
        return "";
      }
    },
    //获取动态字段名称
    getPlaceHolderName(key) {
      let obj = this.filedOptions[key];
      if (!this.$ComTools.isEmptyString(obj)) {
        return obj.placeholder;
      } else {
        return "";
      }
    },
    handleUploadClick(index) {
      if (index === 1) {
        this.$refs.rfile1.click();
      } else {
        this.$refs.rfile2.click();
      }
    },
    handleUploadChange(e, index) {
      let oFile = e.target.files[0];
      let fd = new FormData();
      fd.append("file", oFile);
      Toast.loading({
        message: "上传中...",
        forbidClick: true,
        duration: 0,
      });
      var reader = new FileReader();
      reader.readAsDataURL(oFile);
      reader.onload = (e) => {
        if (index == 1) {
          this.imgCardFrontBase64 = e.target.result;
        } else {
          this.imgCardVersoBase64 = e.target.result;
        }
      };
      uploadIdCard(fd).then((res) => {
        Toast.clear();
        if (index == 1) {
          this.dataForm.urlCardFront = res.data.url;
          let oResult = res.data.result;
          if (!this.$ComTools.isEmptyString(oResult)) {
            this.dataForm.insureIdNo = oResult.number;
            this.dataForm.insureName = oResult.name;
            this.insureBirthday = oResult.birth;
            this.dataForm.insureSex = oResult.sex == "女" ? "2" : "1";
            this.insureSexName = oResult.sex;
            this.dataForm.insureAddress = oResult.address;
            this.dataForm.insureIdNo = oResult.number;
          }
          this.$refs.rfile1.value = null;
        } else {
          this.dataForm.urlCardVerso = res.data.url;
          this.$refs.rfile2.value = null;
        }
      });
    },
    handleProductPickerOk(a, b) {
      this.productValue = a.allName;
      this.showProductPicker = false;
      this.dataForm.categoryId = a.id;
      this.setValue(a);
    },
    setValue(data) {
      this.dataForm.period = data.periodNumber + "年";
      if (
        !this.$ComTools.isEmptyString(data.startTime) &&
        !this.$ComTools.isEmptyString(data.endTime)
      ) {
        this.forceTimeName =
          this.$DateTools.formatDatetime(
            "yyyy年MM月dd日",
            new Date(data.startTime)
          ) +
          "-" +
          this.$DateTools.formatDatetime(
            "yyyy年MM月dd日",
            new Date(data.endTime)
          );
      } else {
        this.forceTimeName =
          this.$DateTools.formatDatetime(
            "yyyy年MM月dd日",
            this.$DateTools.getDateByDay(data.startNumber)
          ) +
          "-" +
          this.$DateTools.changeDate(
            this.$DateTools.getDateByDay(0),
            "YEAR",
            data.periodNumber,
            null,
            "yyyy年MM月dd日"
          );
      }
    },
    handleSendMsgClick() {
      if (this.$ComTools.isEmptyString(this.dataForm.insureMobile)) {
        return Toast("请输入手机号");
      }
      if (!isMobile(this.dataForm.insureMobile)) {
        return Notify("手机号格式错误");
      }
      getVerification({ phone: this.dataForm.insureMobile }).then((res) => {
        if (res.code == 0) {
          Notify({ type: "success", message: "验证码发送成功" });
          this.msgCount--;
          this.msgName = this.msgCount + "秒后重新发送";
          let iKey = setInterval(() => {
            if (this.msgCount == 0) {
              this.msgCount = 61;
              this.msgName = "获取验证码";
              clearInterval(iKey);
            } else {
              this.msgCount--;
              this.msgName = this.msgCount + "秒后重新发送";
            }
          }, 1000);
        } else {
          Notify({ type: "danger", message: res.msg });
        }
      });
    },
    handleShowBlookClick(path) {
      this.$router.push({
        path: path,
      });
    },
    handleGoClick() {
      if (
        this.isNeedVerify("urlCardFront") &&
        this.$ComTools.isEmptyString(this.dataForm.urlCardFront)
      ) {
        return Toast("请上传身份证正面");
      }
      if (
        this.isNeedVerify("urlCardVerso") &&
        this.$ComTools.isEmptyString(this.dataForm.urlCardVerso)
      ) {
        return Toast("请上传身份证背面");
      }
      if (
        this.isNeedVerify("insureMobile") &&
        this.$ComTools.isEmptyString(this.dataForm.insureMobile)
      ) {
        return Toast("请输入手机号");
      }
      if (
        this.isNeedVerify("insureMobile") &&
        !isMobile(this.dataForm.insureMobile)
      ) {
        return Notify("手机号格式错误");
      }
      if (
        this.$ComTools.isEmptyString(this.userInfo.id) &&
        this.isNeedVerify("code") &&
        this.$ComTools.isEmptyString(this.dataForm.code)
      ) {
        return Toast("请输入验证码");
      }
      if (
        this.isNeedVerify("categoryId") &&
        this.$ComTools.isEmptyString(this.dataForm.categoryId)
      ) {
        return Toast("请选择保险产品");
      }
      if (
        this.isNeedVerify("insureIdNo") &&
        this.$ComTools.isEmptyString(this.dataForm.insureIdNo)
      ) {
        return Toast("请上传身份证正面获取身份证号");
      }
      this.dataForm.belongerId = this.belongerId;
      Toast.loading({
        message: "支付中...",
        forbidClick: true,
        duration: 0,
      });
      createInsure(this.dataForm).then((res) => {
        Toast.clear();
        if (res.code === 0 && !this.$ComTools.isEmptyString(res.data)) {
          window.location.href = res.data;
        } else {
          Notify({ type: "danger", message: res.msg });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.form-content {
  width: 100%;
  min-height: 100%;
  .header-box {
    width: 100%;
    display: flex;
    align-items: center;
    padding: 0.8rem;
    .header-icon {
      background-color: #ffc281;
      height: 1.4rem;
      width: 5px;
      display: block;
      margin-right: 0.5rem;
    }
    .header-img {
      width: 1.3rem;
      margin: 0 0.5rem;
    }
    .header-name {
      font-size: 1rem;
      font-weight: 600;
    }
  }
  .idcard-box {
    width: 100%;
    display: flex;
    justify-content: space-around;
  }
  .carimg-box {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 42%;
    .img-item {
      width: 100%;
      height: 96px;
      border: 1px dashed #d9d9d9;
      border-radius: 5px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      background-size: 100% 100%;
    }
    .view-item {
      width: 100%;
      height: 96px;
      border: 1px dashed #d9d9d9;
      border-radius: 5px;
      overflow: hidden;
      position: relative;
      img {
        width: 100%;
        height: 100%;
      }
      .option-view {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        i {
          font-size: 20px;
          color: red;
          display: none;
          cursor: pointer;
        }
        &:hover i {
          display: block;
        }
      }
    }
  }
  /deep/ .van-field__button .van-button--primary {
    background-color: transparent;
    border: none;
    color: #1f95ea;
  }
  .button-save {
    /deep/ .van-button {
      position: fixed;
      bottom: 0;
      left: 0;
      right: 0;
      // color: black !important;
    }
  }
  .check-box {
    width: 100%;
    padding: 0.5rem 1rem;
    display: flex;
    align-items: center;
    /deep/ .van-checkbox__label {
      color: gray;
      font-size: 0.8rem;
    }
    .link-book {
      color: #317cf8;
      font-size: 0.8rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/insurance/insure_driver_form.vue